import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'react-qr-code';
import axios from 'axios';

export default function QRModal({ venueId, token, onClose }) {
  const [qrUrl,   setQrUrl]   = useState('');
  const [loading, setLoading] = useState(true);
  const [rotating, setRotating] = useState(false);
  const [copied,  setCopied]  = useState(false);
  const qrRef = useRef(null);

  const headers = { Authorization: `Bearer ${token}` };

  const fetchToken = async () => {
    try {
      const r = await axios.get(`/v1/venues/${venueId}/pre-registration-token`, { headers });
      setQrUrl(r.data.url);
    } catch (err) {
      console.error('QRModal: failed to load QR token', err);
      setQrUrl('');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchToken(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const rotateToken = async () => {
    if (!window.confirm('¿Rotar el QR? El enlace anterior dejará de funcionar.')) return;
    setRotating(true);
    try {
      const r = await axios.post(`/v1/venues/${venueId}/pre-registration-token`, {}, { headers });
      setQrUrl(r.data.url);
    } catch (err) {
      console.error('QRModal: failed to rotate QR token', err);
    } finally {
      setRotating(false);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(qrUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const downloadQR = () => {
    const svg = qrRef.current?.querySelector('svg');
    if (!svg) return;
    const blob = new Blob([svg.outerHTML], { type: 'image/svg+xml' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'qr-preinscripcion.svg';
    a.click();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-gray-900">QR de Preinscripción</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl">×</button>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full" />
          </div>
        ) : qrUrl ? (
          <>
            <p className="text-sm text-gray-500 mb-4 text-center">
              Muestra o imprime este código para que los socios potenciales rellenen su solicitud.
            </p>
            <div ref={qrRef} className="flex justify-center p-4 bg-white border border-gray-100 rounded-xl mb-4">
              <QRCode value={qrUrl} size={200} />
            </div>
            <p className="text-xs text-gray-400 break-all text-center mb-4">{qrUrl}</p>
            <div className="flex flex-col gap-2">
              <button onClick={copyLink}
                className="w-full py-2 bg-purple-600 text-white rounded-lg text-sm font-medium hover:bg-purple-700 transition-colors">
                {copied ? '✓ Enlace copiado' : '🔗 Copiar enlace'}
              </button>
              <button onClick={downloadQR}
                className="w-full py-2 border border-gray-300 text-gray-700 rounded-lg text-sm hover:bg-gray-50 transition-colors">
                ⬇ Descargar QR (SVG)
              </button>
              <button onClick={rotateToken} disabled={rotating}
                className="w-full py-2 border border-red-200 text-red-500 rounded-lg text-xs hover:bg-red-50 transition-colors disabled:opacity-50">
                {rotating ? 'Rotando…' : '🔄 Rotar QR (invalida el anterior)'}
              </button>
            </div>
          </>
        ) : (
          <p className="text-center text-red-500 text-sm py-8">No se pudo cargar el QR.</p>
        )}
      </div>
    </div>
  );
}
